/* eslint-disable no-await-in-loop */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import * as $ from 'jquery';
import { jQuery } from 'jquery';
import { Loading } from '../../../Common/Loading';
import { findOrNewSerieCache } from './loadingCache';
import { getVolumeManager, to3DLibraryToolName } from '../../getVolumeManager';
import toolNames from '../../../Header/Toolbar/toolNames';
import { handleDoubleTouch } from '../../../../../util/touchEventUtils';
import {
  changeFullViews,
  selectView,
  setLayout2DMode,
  setLayout3DMode,
  setLayout3DModeMobile,
  setLayoutMPRMode,
  setLayoutMPRModeMobile,
} from '../../Layout/LayoutUtils';
import { useSelector } from 'react-redux';
import store from '../../../../../store/store';
import { setCurrentTool, setIs3DModeEnabled, setIsMPRModeEnabled } from '../../../../../actions/LayoutActions';
import { TYPE_OPTION_VR } from './volumeInitOptions';
import { isChildViewport as isChildViewportWindow } from '../../../../../util/isChildViewport';
import {
  createActiveViewportContext,
  getCrossWindowWindowId,
  setCrossWindowActiveViewport,
  updateCrossWindowActiveViewportContext,
} from '../../crossWindow2dReferenceLines';
import { CSS_PIXELS_PER_MM } from '../screenScale';

window.$ = $;
window.jQuery = jQuery;

const TOUCH_START_WEB_VOLUME = 'touchStartWebVolume';

export const styles = {
  width: '100%',
  height: '100%',
  position: 'relative',
};

const randomNumber = (length) => {
  let text = '';
  let possible = '123456789';
  for (let i = 0; i < length; i++) {
    let sup = Math.floor(Math.random() * possible.length);
    text += i > 0 && sup === i ? '0' : possible.charAt(sup);
  }
  return Number(text);
};

export const defaultInit3D = { currentTool: 'windowLevel' };

export const Image3d = ({ instanceIds, initOptions, button, cubeCamSelector, index }) => {
  // TODO: this in one line
  if (getVolumeManager() === undefined) {
    return (
      <>
        {button}
        <h5>Webgl2 not supported, please update your browser or platform</h5>
      </>
    );
  }

  const layout = useSelector((state) => state.layout);
  const currentToolRef = useRef(layout.currentTool);
  currentToolRef.current = layout.currentTool;

  const config = useSelector((state) => state.config);

  const instanceIdsKey = instanceIds.join('\u0000');
  const stableInstanceIds = useMemo(() => instanceIds, [instanceIdsKey]);

  const [id] = useState(randomNumber(16));
  const [viewType, setViewType] = useState(initOptions.viewType.type);
  const [camera, setCamera] = useState(initOptions.viewType.camera);
  const [serieCache, setSerie] = useState(() => findOrNewSerieCache(stableInstanceIds));

  const elementRef = useRef();
  const loadingRef = useRef();
  const isChildViewport = isChildViewportWindow();

  const activateCurrentTool = useCallback((toolName) => {
    if (!isChildViewport) return;
    const volumeManager = serieCache.volumeManager3d;
    if (!volumeManager || !toolName) return;

    if (toolName === toolNames.CROSS_REFERENCE) {
      volumeManager.changeTool('crossRef', 'left');
      return;
    }

    if (toolName === toolNames.ERASER) {
      volumeManager.annotationEraserPreviousTool = toolNames.CROSS_REFERENCE;
      volumeManager.annotationEraserMode = true;
      return;
    }

    const annotationModes = {
      [toolNames.LENGTH]: 'rule',
      [toolNames.ANGLE]: 'angle',
      [toolNames.COBB_ANGLE]: 'cobbAngle',
      [toolNames.RECTANGLE_ROI]: 'rectangle',
      [toolNames.ELLIPTICAL_ROI]: 'ellipse',
      [toolNames.FREEHAND_ROI]: 'freeHand',
    };
    if (annotationModes[toolName]) {
      volumeManager.annotationEraserMode = false;
      volumeManager.changeAnnotationMode(annotationModes[toolName], undefined, 'left', volumeManager.lastTool);
      return;
    }

    if ([toolNames.WWWC, toolNames.ZOOM, toolNames.PAN, toolNames.ROTATE, toolNames.CLIPPING].includes(toolName)) {
      volumeManager.annotationEraserMode = false;
      volumeManager.changeTool(to3DLibraryToolName(toolName), 'left', undefined);
    }
  }, [isChildViewport, serieCache]);

  useEffect(() => {
    activateCurrentTool(layout.currentTool);
  }, [activateCurrentTool, layout.currentTool]);

  useEffect(() => {
    const handleActiveViewportCommand = (event) => {
      const { windowId, viewIndex, toolName, commandOptions } = event.detail || {};
      const localWindowId = getCrossWindowWindowId();
      if (viewIndex !== index || (windowId && windowId !== localWindowId)) return;

      const volumeManager3d = serieCache.volumeManager3d;
      const activeView = volumeManager3d?.all_views?.find((view) => view.div === elementRef.current);
      if (!activeView) return;

      if (toolName === toolNames.REF_LINES) {
        const mprViews = volumeManager3d.all_views.filter(
          (view) => view.appFlagsObj.viewType === 'mpr'
        );
        if (mprViews.length === 0) return;
        const enabled = !mprViews.every(
          (view) => view.options.axisIntersectionLinesEnabled !== false
        );
        mprViews.forEach((view) => {
          view.options.axisIntersectionLinesEnabled = enabled;
          view.appFlagsObj.useChangeProxyGeometry('toolbar3d.toggleReferenceLines');
        });
        updateCrossWindowActiveViewportContext({ referenceLinesVisible: enabled });
        return;
      }

      if (toolName === toolNames.CLIPPING) {
        volumeManager3d.selectView(activeView, undefined, false);
        volumeManager3d.changeTool('clipping', 'left', undefined);
        return;
      }

      if (commandOptions?.paletteName) {
        if (commandOptions.paletteType === 'vr' && activeView.appFlagsObj.viewType === 'vr') {
          activeView.usePalette(commandOptions.paletteName, true);
        } else if (commandOptions.paletteType === 'mpr') {
          volumeManager3d.all_views
            .filter((view) => view.appFlagsObj.viewType === 'mpr')
            .forEach((view) => view.mprState.setPalette(commandOptions.paletteName, true, true));
        }
        return;
      }

      if ([toolNames.MODE_2D, toolNames.MODE_MPR, toolNames.MODE_3D].includes(toolName)) {
        const { layout } = store.getState();
        const layoutElement = layout.elements[index];
        if (!layoutElement) return;

        if (toolName === toolNames.MODE_2D) {
          setLayout2DMode(layoutElement);
          store.dispatch(setCurrentTool(toolNames.WWWC));
        } else if (toolName === toolNames.MODE_MPR) {
          store.dispatch(setIsMPRModeEnabled(true));
          store.dispatch(setIs3DModeEnabled(false));
          isMobile ? setLayoutMPRModeMobile(layoutElement) : setLayoutMPRMode(layoutElement);
          store.dispatch(setCurrentTool(toolNames.CROSS_REFERENCE));
        } else {
          store.dispatch(setIs3DModeEnabled(true));
          store.dispatch(setIsMPRModeEnabled(false));
          isMobile ? setLayout3DModeMobile(layoutElement) : setLayout3DMode(layoutElement);
        }
        return;
      }

      volumeManager3d.selectView(activeView, undefined, false);
      switch (toolName) {
        case toolNames.ROTATE90:
          volumeManager3d.api.rotateCamera(90);
          break;
        case toolNames.ROTATE270:
          volumeManager3d.api.rotateCamera(-90);
          break;
        case toolNames.HFLIP:
          volumeManager3d.api.flipCamera('x');
          break;
        case toolNames.VFLIP:
          volumeManager3d.api.flipCamera('y');
          break;
        case toolNames.RESET_POSITION:
          volumeManager3d.api.rotateCamera();
          volumeManager3d.api.flipCamera();
          volumeManager3d.api.zoomCamera();
          volumeManager3d.api.resetPan();
          break;
        case toolNames.ZOOM_1_TO_1:
          volumeManager3d.api.zoomCamera(100 * (1 - activeView.camera.zoom));
          break;
        case toolNames.ZOOM_FIT:
          volumeManager3d.api.zoomCamera();
          break;
        case toolNames.ZOOM_ACTUAL_SIZE: {
          const pixelSpacing = activeView.dicomObj?.minPixelSpacing
            ?? Math.min(...(activeView.dicomObj?.pixelSpacing || []));
          if (!Number.isFinite(pixelSpacing) || pixelSpacing <= 0) break;
          const targetZoom = CSS_PIXELS_PER_MM * pixelSpacing;
          volumeManager3d.api.zoomCamera(100 * (1 - targetZoom * activeView.camera.zoom));
          break;
        }
        default:
          break;
      }
    };

    window.addEventListener('viewer-active-viewport-command', handleActiveViewportCommand);
    return () => window.removeEventListener('viewer-active-viewport-command', handleActiveViewportCommand);
  }, [index, serieCache]);

  useEffect(() => {
    if (config.RENDERING_3D_TYPE) {
      if (initOptions.viewType && initOptions.viewType.type === TYPE_OPTION_VR) {
        initOptions.viewType.renderingType = config.RENDERING_3D_TYPE;
      }
    }
  }, [camera]);

  useEffect(() => {
    elementRef.current.addEventListener(TOUCH_START_WEB_VOLUME, (e) => {
      selectView(index);

      handleDoubleTouch(e, () => {
        changeFullViews();
        serieCache.changeView(elementRef.current);
      });
    });
  }, []);

  const handleDoubleClick = () => {
    serieCache.changeView(elementRef.current);
  };

  useEffect(() => {
    const show = async () => {
      await serieCache.getFirstImages();

      serieCache.addView(elementRef.current, initOptions, loadingRef);
      serieCache.startLoading(elementRef.current);
      if (isChildViewport) {
        const layout = store.getState().layout;
        setCrossWindowActiveViewport(index, createActiveViewportContext(layout, index));
      }
      activateCurrentTool(currentToolRef.current);
    };

    show();

    return () => {
      serieCache.removeViewId(id, loadingRef);
      // serieCache.clearAllViews();
    };
  }, []);

  useEffect(() => {
    setViewType(initOptions.viewType.type);
    setCamera(initOptions.viewType.camera);
    const downHandler = (event) => {
      const isDeleteKey = event.key === 'Delete' || event.keyCode === 46;
      const target = event.target;
      const isEditingText = target instanceof Element
        && (target.isContentEditable || target.closest('input, textarea, select, [contenteditable="true"]'));
      const volumeManager = serieCache.volumeManager3d;

      if (
        isDeleteKey
        && !event.repeat
        && !event.ctrlKey
        && !event.altKey
        && !event.metaKey
        && !isEditingText
        && volumeManager?.areAnnotationsSelected()
      ) {
        event.preventDefault();
        volumeManager.deleteSelectedAnnotations();
        return;
      }

      serieCache.downHandler(elementRef.current, initOptions.viewType.type, event);
    };

    const changeSerie = async () => {
      serieCache.removeViewId(id, loadingRef);

      const serie = findOrNewSerieCache(stableInstanceIds);

      await serie.getFirstImages();
      serie.addView(elementRef.current, initOptions, loadingRef);
      serie.startLoading(elementRef.current);
      activateCurrentTool(currentToolRef.current);

      setSerie(serie);
    };

    if (serieCache.instances[0] !== stableInstanceIds[0] || viewType !== initOptions.viewType.type || camera !== initOptions.viewType.camera) {
      changeSerie();
    }

    serieCache.resizeViews();

    window.addEventListener('keydown', downHandler);
    window.addEventListener('dblclick', handleDoubleClick);
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('dblclick', handleDoubleClick);
    };
  }, [camera, viewType, initOptions.viewType.type, initOptions.viewType.camera, stableInstanceIds, serieCache]);

  useEffect(() => {
    const disableRightClick = (e) => {
      e.preventDefault();
    };

    const element = elementRef.current;

    element.addEventListener('contextmenu', disableRightClick);

    return () => {
      element.removeEventListener('contextmenu', disableRightClick);
    };
  }, []);

  return (
    <>
      {button}
      <div ref={elementRef} id={id} data-view-index={index} style={styles} />
      <Loading loadingRef={loadingRef} />
      {cubeCamSelector}
    </>
  );
};

export default Image3d;
